var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8602 9.1307C21.6636 8.89851 16.9808 3.44531 10.9999 3.44531C5.01902 3.44531 0.33593 8.89851 0.139606 9.13048C-0.0465352 9.35076 -0.0465352 9.64953 0.139606 9.86981C0.33593 10.102 5.01902 15.5552 10.9999 15.5552C16.9808 15.5552 21.6636 10.102 21.8602 9.87C22.0466 9.64975 22.0466 9.35076 21.8602 9.1307ZM10.9999 14.3025C6.59434 14.3025 2.77867 10.6831 1.64914 9.49983C2.7772 8.31556 6.58489 4.69805 10.9999 4.69805C15.4052 4.69805 19.2206 8.31682 20.3506 9.50068C19.2226 10.6849 15.4149 14.3025 10.9999 14.3025Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 5.74219C8.60046 5.74219 6.64825 7.42818 6.64825 9.50045C6.64825 11.5727 8.60046 13.2587 10.9999 13.2587C13.3994 13.2587 15.3516 11.5727 15.3516 9.50045C15.3516 7.42818 13.3994 5.74219 10.9999 5.74219ZM10.9999 12.0059C9.40019 12.0059 8.09884 10.882 8.09884 9.50045C8.09884 8.1189 9.40024 6.99497 10.9999 6.99497C12.5996 6.99497 13.901 8.1189 13.901 9.50045C13.901 10.882 12.5997 12.0059 10.9999 12.0059Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.10f33958d1c3bd56ce775eb24b5bf90e.svg";
export { ForwardRef as ReactComponent };